import React, { FC } from 'react';
import { ComponentRendering, isEditorActive, Text } from '@sitecore-jss/sitecore-jss-react';
import LineItem from './components/lineItem';
import { appendToUrlPath } from '../../utils';
import { ProductLinesListingModel } from './model/productLinesListing.model';
import { TProductLinesListingProps } from './types/productLinesListing.types';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import useExperiencerEditorPlaceholder from '../../hooks/useExperiencerEditorPlaceholder';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';

const ProductLinesListing: FC<TProductLinesListingProps> = (props) => {
  const model = new ProductLinesListingModel(props);
  const apiResponse = isEmptyResponse(props);
  const lineItems = model?.productListData?.items || [];
  const isPlaceholderShown = useExperiencerEditorPlaceholder(props);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  // placeholder thumbnail is not required as the component is in products page and always loaded with component data

  // data missing
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={model.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  return (
    <AnalyticsVisibleEvent
      rendering={props?.rendering as ComponentRendering}
      title={props.fields?.itemData?.fields?.lineListingTitle?.value ?? ''}
      template="Line Listing"
    >
      <section className="product-line-listing">
        <div className="product-line-listing__container">
          {model.title && <Text field={model.title} className="product-line-listing__title" tag="span" />}
          <div className="product-line-listing__line-listing">
            {lineItems.map((lineItem, i) => (
              <LineItem
                url={appendToUrlPath(model.url || '', lineItem.titleUrl)}
                lineItem={lineItem}
                key={lineItem?.id}
                componentNumber={i + 1}
              />
            ))}
          </div>
        </div>
      </section>
    </AnalyticsVisibleEvent>
  );
};

export default ProductLinesListing;
